import { LinkKind } from "./types";

export interface ClassifiedUrl {
  url: string;
  kind: LinkKind;
  domain: string;
  // Video id (YouTube / Vimeo) when kind is a video.
  videoId?: string;
}

// Classify a raw URL into a YouTube / Vimeo / generic-website link. Returns
// null when the string is not a usable URL. Carries no metadata guesses —
// title/description/image only ever come from the server unfurl (eager
// fetch on add, reconciled via the post-save job as a fallback).
export const classifyUrl = (raw: string): ClassifiedUrl | null => {
  let url = raw.trim();
  if (!/^https?:\/\//i.test(url)) url = `https://${url}`;

  let host: string;
  try {
    host = new URL(url).hostname;
  } catch {
    return null;
  }

  const domain = host.replace(/^www\./, "");

  const youtube = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/i,
  );
  if (youtube) {
    return { url, kind: "youtube", domain: "youtube.com", videoId: youtube[1] };
  }

  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d{6,})/i);
  if (vimeo) {
    return { url, kind: "vimeo", domain: "vimeo.com", videoId: vimeo[1] };
  }

  return { url, kind: "link", domain };
};
